/* Millesève — la planche par rubrique de l'en-tête du Tirage (E7.6 ; E7.11, maquette v84, proposition A).
   Rendu par sections/header.liquid. Chaque rubrique de la barre (bouton [data-planche-ouvre]) ouvre son seul panneau
   (aria-controls), posé sous son mot (--x) ; la hauteur de la planche glisse d'un panneau à l'autre.
   Ouverture : clic, toucher, Entrée/Espace, flèche bas (focus sur le 1er lien), survol à la souris (140 ms ; 80 ms d'une
   rubrique à l'autre, pour ne pas clignoter en diagonale).
   Fermeture : Échap (focus rendu au bouton), clic ailleurs, focus qui sort, passage sous 750 px ; et, si ouverte au survol,
   souris qui quitte l'en-tête ou passe sur un lien direct de la barre ([data-planche-direct]).
   Clavier : Tab depuis un bouton ouvert entre dans son panneau (et lui seul), Tab depuis le dernier lien reprend à
   l'élément suivant de la barre, Maj+Tab depuis le premier lien revient au bouton, flèches entre les liens du panneau.
   Mouvement réduit : les jetons mettent --dur-fast à 0 s, rien à faire ici. */
if (!customElements.get('ms-entete')) {
  class MsEntete extends HTMLElement {
    connectedCallback() {
      this.planche = this.querySelector('.ms-planche');
      this.pans = this.querySelector('.ms-planche__pans');
      this.boutons = Array.from(this.querySelectorAll('[data-planche-ouvre]'));
      if (!this.planche || !this.pans || !this.boutons.length) return;
      this.ouvert = null;
      this.par = null;

      this.boutons.forEach((bouton) => {
        bouton.addEventListener('click', () => {
          if (this.ouvert === bouton && this.par === 'clic') this.ferme(false);
          else this.ouvre(bouton, 'clic');
        });
        bouton.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowDown') return;
          event.preventDefault();
          event.stopPropagation();
          this.ouvre(bouton, 'clic', true);
        });
        bouton.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(this.tFerme);
          clearTimeout(this.tOuvre);
          if (this.ouvert === bouton) return;
          const par = this.ouvert && this.par === 'clic' ? 'clic' : 'survol';
          this.tOuvre = setTimeout(() => this.ouvre(bouton, par), this.ouvert ? 80 : 140);
        });
        bouton.addEventListener('pointerleave', () => clearTimeout(this.tOuvre));
      });

      // une rubrique sans sous-liens est un lien direct : le panneau ouvert au survol se referme en fondu
      this.querySelectorAll('[data-planche-direct]').forEach((lien) => {
        lien.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse' || !this.ouvert || this.par !== 'survol') return;
          clearTimeout(this.tOuvre);
          clearTimeout(this.tFerme);
          this.tFerme = setTimeout(() => this.ferme(false), 140);
        });
      });

      this.planche.addEventListener('pointerenter', () => clearTimeout(this.tFerme));
      this.addEventListener('pointerenter', () => clearTimeout(this.tFerme));
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse' && this.par === 'survol') {
          clearTimeout(this.tFerme);
          this.tFerme = setTimeout(() => this.ferme(false), 260);
        }
      });
      this.addEventListener('focusout', (event) => {
        const vers = event.relatedTarget;
        if (this.ouvert && vers && !this.boutons.includes(vers) && !this.planche.contains(vers)) this.ferme(false);
      });
      this.addEventListener('keydown', (event) => this.clavier(event));

      this.surDocument = (event) => {
        if (this.ouvert && !this.contains(event.target)) this.ferme(false);
      };
      this.surEchap = (event) => {
        if (event.key === 'Escape' && this.ouvert) {
          event.preventDefault();
          this.ferme(true);
        }
      };
      this.surTaille = () => {
        if (!this.ouvert) return;
        this.planche.classList.remove('est-glisse');
        this.mesure(this.ouvert);
      };
      document.addEventListener('pointerdown', this.surDocument);
      document.addEventListener('keydown', this.surEchap);
      window.addEventListener('resize', this.surTaille);

      this.etroit = window.matchMedia('(max-width: 749px)');
      this.surEtroit = (event) => {
        if (event.matches) this.ferme(false);
      };
      this.etroit.addEventListener('change', this.surEtroit);
    }

    disconnectedCallback() {
      clearTimeout(this.tOuvre);
      clearTimeout(this.tFerme);
      if (this.surDocument) document.removeEventListener('pointerdown', this.surDocument);
      if (this.surEchap) document.removeEventListener('keydown', this.surEchap);
      if (this.surTaille) window.removeEventListener('resize', this.surTaille);
      if (this.etroit) this.etroit.removeEventListener('change', this.surEtroit);
    }

    panDe(bouton) {
      return document.getElementById(bouton.getAttribute('aria-controls'));
    }

    // les liens du seul panneau ouvert
    liens() {
      const pan = this.ouvert && this.panDe(this.ouvert);
      return pan ? Array.from(pan.querySelectorAll('a[href]')) : [];
    }

    // la liste se pose sous le mot du bouton ; la planche prend la hauteur de son panneau
    mesure(bouton) {
      const pan = this.panDe(bouton);
      if (!pan) return;
      const x = Math.round(bouton.getBoundingClientRect().left - this.planche.getBoundingClientRect().left);
      pan.style.setProperty('--x', `${Math.max(0, x)}px`);
      this.pans.style.height = `${pan.offsetHeight}px`;
    }

    ouvre(bouton, par, focusPremier) {
      clearTimeout(this.tFerme);
      const pan = this.panDe(bouton);
      if (!pan) return;
      const deja = Boolean(this.ouvert);
      if (this.ouvert && this.ouvert !== bouton) {
        this.ouvert.setAttribute('aria-expanded', 'false');
        const avant = this.panDe(this.ouvert);
        if (avant) avant.classList.remove('est-actif');
      }
      this.ouvert = bouton;
      this.par = par;
      bouton.setAttribute('aria-expanded', 'true');
      // la hauteur ne glisse que d'un panneau à l'autre : à l'ouverture, la planche apparaît en fondu à sa hauteur
      this.planche.classList.toggle('est-glisse', deja);
      pan.classList.add('est-actif');
      this.mesure(bouton);
      this.planche.classList.add('est-ouvert');
      this.classList.add('est-deploye');
      if (focusPremier) {
        // la visibilité s'ouvre sans délai (transition de visibility à 0 s) : le lien peut prendre le focus tout de suite
        const premier = this.liens()[0];
        if (premier) premier.focus();
      }
    }

    // la hauteur reste en place pendant le fondu de fermeture
    ferme(rendFocus) {
      clearTimeout(this.tFerme);
      clearTimeout(this.tOuvre);
      if (!this.ouvert) return;
      const bouton = this.ouvert;
      this.ouvert = null;
      this.par = null;
      bouton.setAttribute('aria-expanded', 'false');
      const pan = this.panDe(bouton);
      if (pan) pan.classList.remove('est-actif');
      this.planche.classList.remove('est-ouvert', 'est-glisse');
      this.classList.remove('est-deploye');
      if (rendFocus) bouton.focus();
    }

    // la planche suit la barre dans le code : on relie Tab et les flèches comme si le panneau était sous son bouton
    clavier(event) {
      if (!this.ouvert) return;
      const liens = this.liens();
      const actif = document.activeElement;
      const i = liens.indexOf(actif);
      if (event.key === 'Tab') {
        if (!event.shiftKey && actif === this.ouvert) {
          if (liens[0]) {
            event.preventDefault();
            liens[0].focus();
          }
        } else if (!event.shiftKey && i >= 0 && i === liens.length - 1) {
          const barre = Array.from(this.querySelectorAll('.ms-head__bar a[href], .ms-head__bar button')).filter(
            (el) => el.offsetParent !== null
          );
          const bouton = this.ouvert;
          const suivant = barre[barre.indexOf(bouton) + 1];
          this.ferme(false);
          if (suivant) {
            event.preventDefault();
            suivant.focus();
          }
        } else if (event.shiftKey && i === 0) {
          event.preventDefault();
          this.ouvert.focus();
        }
      } else if (['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft'].includes(event.key) && i >= 0) {
        event.preventDefault();
        const pas = event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : liens.length - 1;
        liens[(i + pas) % liens.length].focus();
      }
    }
  }

  customElements.define('ms-entete', MsEntete);
}
